import $ from "jquery";

//Need to add the piece of code below so that closing topicref tags are maintained - https://jquery.com/upgrade-guide/3.5/
export function rxhtmltag4jQuery(){
    var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
    $.htmlPrefilter = function (html) {
      return html.replace(rxhtmlTag, "<$1></$2>");
    };
}